import React from "react";
import GroupHeadAllDealsModal from "../../dashboard-util/dashboard-grouphead/group-head-all-deals-modal"
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import PropTypes from "prop-types";

const CMEGroupHeadAllDealsModal = ({ show, onHide, item }) => {
    const tableHeaders = ["Deal", "Team", "Project Name", "SubSector", "Project Type", "Deliverable Due Date", "MD", "Director", "Vice President"];

    const renderProjectRow = (project) => (
        <tr key={project.ProjectId} data-testid={`project-${project.ProjectId}`}>
            <td className="col-md-1 col-sm-1 mt-2"> {project.CompanyName} </td>
            <td className="col-md-1 col-sm-1 mt-2 cmeMemberColumn">
                <ViewMembersPanelNew
                    members={project?.Members}
                    projects={project}
                    isHidden={true}
                />
            </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.ProjectName} </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.SubSector} </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.DealType} </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.DeliverableDueDate} </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.MD} </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.D} </td>
            <td className="col-md-1 col-sm-1 mt-2"> {project.VP} </td>
        </tr>
    );

    return (
        <GroupHeadAllDealsModal
            show={show}
            onHide={onHide}
            item={item}
            departmentTitle="GIB/CME"
            additionalHeaderContent={item.GroupHeadIndicator}
            tableHeaders={tableHeaders}
            renderProjectRow={renderProjectRow}
        />
    );
};

CMEGroupHeadAllDealsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    item: PropTypes.shape({
        GroupHeadName: PropTypes.string,
        GroupHeadIndicator: PropTypes.string,
        Projects: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
};

export default React.memo(CMEGroupHeadAllDealsModal);
